document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.header__mobile-search-trigger');
  if (!trigger) return;

  const header = trigger.closest('header');
  const search = header?.querySelector('.header__search');
  const input = search?.querySelector('input[type="search"]');
  if (!search || !input) return;

  search.classList.add('palmera-mobile-search-visible');
  document.body.classList.add('search-open');
  requestAnimationFrame(() => input.focus());
});

const mobileSearchObserver = new MutationObserver(() => {
  if (document.body.classList.contains('search-open')) return;
  document.querySelectorAll('.palmera-mobile-search-visible').forEach((search) => {
    search.classList.remove('palmera-mobile-search-visible');
  });
});

mobileSearchObserver.observe(document.body, {
  attributes: true,
  attributeFilter: ['class'],
});


const updatePalmeraPurchasePills = (productSection, variantPrice) => {
  const label = productSection?.querySelector('.palmera-purchase-pill--shipping .inline-richtext');
  if (!label || !Number.isFinite(variantPrice)) return;
  const goal = document.querySelector('free-shipping-goal[data-minimum-amount]');
  const baseLimit = goal ? Number(goal.dataset.minimumAmount) * 100 : Number(productSection.querySelector('.palmera-purchase-pills')?.dataset.shippingLimit || 0);
  const limit = baseLimit * Number(window.Shopify?.currency?.rate || 1);
  const text = limit > 0 && variantPrice >= limit ? 'Gratis frakt' : 'Rask levering';
  if (label.textContent !== text) label.textContent = text;
};
document.addEventListener('DOMContentLoaded', () => {
  const productSection = document.querySelector('.section-main-product');
  updatePalmeraPurchasePills(productSection, Number(productSection?.querySelector('.palmera-purchase-pills')?.dataset.productPrice));
  if (!window.FoxTheme?.pubsub) return;
  FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, event => {
    const section = document.querySelector('.section-main-product');
    if (!section || event.data.sectionId !== section.dataset.section) return;
    updatePalmeraPurchasePills(section, event.data.variant?.price);
    const id = 'PalmeraSaleBadge-' + section.dataset.section;
    const source = event.data.html?.getElementById(id);
    const destination = document.getElementById(id);
    if (source && destination) destination.innerHTML = source.innerHTML;
  });
});
document.addEventListener('click', event => {
  if (!event.target.closest('.section-main-product .palmera-rating-link')) return;
  const reviews = document.getElementById('palmera-product-reviews');
  if (!reviews) return;
  event.preventDefault();
  reviews.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
});
